import { emptyingDetectionLogsOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import dayjs from "dayjs";
import { defineEntity } from "../api/entity";

const conf = defineEntity({
  ...entityFactory("emptying-detection-logs"),
  endpoint: "emptying-detection-logs",
  operations: emptyingDetectionLogsOps,
  roleView: [ROLE.EMZ_DEVELOPER],
  roleAdmin: [ROLE.EMZ_DEVELOPER],
  singularName: (t) => t("Container emptying log"),
  name: (t) => t("Container emptying logs"),
  initialFilter: {
    sortBy: "timestamp",
    sortOrder: "descend",
    from: dayjs().startOf("month").subtract(1, "months").format(),
    to: dayjs().format(),
  },
  syncCustomerFilter: true,
});

export default conf;
